var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":_vm.onToggle}},[_c('svg-icon',{attrs:{"icon":_vm.isFullScreen ? 'exit-fullscreen' : 'fullscreen'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }